module.exports = __webpack_public_path__ + "static/media/ashely.114eb943.png";